import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useIntl } from 'react-intl';
import { DownloadKS } from '../../../components';

export const DownloadKSGroup = () => {
  const intl = useIntl();
  return (
    <Box
      id="download-ks-group"
      key="download-ks-group"
      border={theme => `1px solid ${theme.refV2.cat.gray[200]}`}
      display="flex"
      flexDirection="column"
      marginTop={2}
      padding={4}
      width="100%"
      sx={theme => ({
        [theme.breakpoints.down('tablet')]: {
          width: '100%',
        },
      })}
    >
      <Box
        id="download-ks-group-desc"
        key="download-ks-group-desc"
        display="flex"
        alignContent="center"
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <Typography variant="body1" fontWeight={500} fontSize={16}>
          {intl.formatMessage(
            { id: 'page.subscription.download.ks.desc' },
            {
              oneMonth: <b style={{ color: '#5959EB' }}>1-month trial</b>,
            },
          )}
        </Typography>
      </Box>
      <Box
        id="download-ks-group-explore-plan"
        key="download-ks-group-explore-plan"
        display="flex"
        alignContent="center"
        alignItems="center"
        justifyContent="center"
        width="100%"
        paddingTop={2}
      >
        <DownloadKS />
      </Box>
    </Box>
  );
};
